import React, { Suspense } from "react";
import { useMsal } from "@azure/msal-react";
import { useDispatch } from "react-redux";
import { myCartLoginRequest } from "../../authConfig";
import { useLocation, useNavigate } from "react-router-dom";
import { handleDeleteAction } from "./cartUtils";
import styles from "./userConfirmation.module.scss";

const NavBar = React.lazy(() => import("../../components/navBar"));
const TopicBanner = React.lazy(() => import("../../components/SubscribeTopicBanner"));
const Footer = React.lazy(() => import("../../components/footer"));

const UserConfirmation = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { instance } = useMsal();

  const cartItems = location.state?.cartItems;

  const handleGoToCheckout = async () => {
    if (!cartItems) {
      alert("No items in cart. Redirecting to cart page.");
      navigate("/myCart");
      return;
    }
    if (cartItems.ordertype === "Addon" || cartItems.ordertype === "Renew") {
      try {
        const cartType = cartItems.subscriptionid === "151" ? "single" : "multiple";

        const response = await handleDeleteAction(cartItems.cartsid, cartType, dispatch);

        if (response?.success) {
          alert(
            "We noticed you're trying to renew or add licenses without signing in first. We will clear your cart. New customer? You can grab a fresh subscription from our homepage. Already have an account? Just sign in and visit My Account >> My Subscriptions to renew or addon licenses.",
          );
          navigate("/");
          return;
        }
      } catch (error) {
        console.warn("Error in checking out", error);
        alert("Network error. Please try again.");
        return;
      }
    }

    navigate("/checkout", {
      state: { cartItems: cartItems },
    });
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      // // 1) Grab the cart items from location.state
      // const cartItems = location?.state?.cartItems || [];

      // // 2) Stringify them in your custom state object
      // const stateObj = JSON.stringify({
      //   redirectTo: '/checkout',
      //   cartItems: cartItems,
      // });

      await instance.loginRedirect({
        ...myCartLoginRequest,
        state: location?.state?.cartItems || [],
        // redirectUri: `${window.location.origin}/mycart`,
        redirectStartPage: "/myCart",
        // state: stateObj
      });
    } catch (err) {
      console.log("login error in user confirmation page", err);
    }
  };

  return (
    <>
      <Suspense fallback={<div className="loader"></div>}>
        <NavBar push={navigate} />
        <TopicBanner />
        <div className={styles.userConfirmation}>
          <div className={styles.columns}>
            {/* Returning subscribers */}
            <div className={styles.column}>
              <div className={styles.heading}>Returning customers</div>
              <div className={styles.divider} />

              <p className={styles.subheading}>
                If you are returning customer, please <strong>log in</strong> here.
              </p>

              <button className={styles.primaryButton} onClick={handleLogin}>
                Log in
              </button>
            </div>

            {/* New subscriber */}
            <div className={styles.column}>
              <div className={styles.heading}>New subscriber</div>
              <div className={styles.divider} />

              <p className={styles.subheading}>
                To complete your subscription purchase please tap the{" "}
                <strong>Continue to checkout </strong>button. If you are interested in subscribing
                to multiple products you can now easily switch between web apps. If you’d like to
                use our integrated web app options, please use the same email address to subscribe
                to all our online clinical resources.
              </p>

              <button className={styles.primaryButton} onClick={handleGoToCheckout}>
                Continue to checkout
              </button>
            </div>
          </div>
        </div>

        <Footer />
      </Suspense>
    </>
  );
};

export default UserConfirmation;
